// pages/AgendaPage.js o donde desees usarlo
import React from 'react';
import { Box } from '@mui/material';
import ServiceOrderDetail from '../../components/administration/serviceOrders/detail/ServiceOrderDetail'

const ServicioDetallePage2 = () => {
    return (
        <Box sx={{ p: 2 }}>
            <ServiceOrderDetail
                onReorder={(newOrder) => {
                    console.log('Nuevo orden de ordenes de servicio detalle v2:', newOrder);
                }}
            />
        </Box>
    );
};

export default ServicioDetallePage2;
